import { render, staticRenderFns } from "./thirdPartyData.vue?vue&type=template&id=656aeb29&scoped=true&"
import script from "./thirdPartyData.vue?vue&type=script&lang=js&"
export * from "./thirdPartyData.vue?vue&type=script&lang=js&"
import style0 from "./thirdPartyData.vue?vue&type=style&index=0&id=656aeb29&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656aeb29",
  null
  
)

export default component.exports